import Flatpickr from "react-flatpickr";

import { memo } from "react";
import { Options } from "flatpickr/dist/types/options";
import { Vietnamese } from "flatpickr/dist/l10n/vn.js";

import FormField from "../FormField";
import TitleValue from "../TitleValue";
import Helpers from "../../commons/helpers";
import Strings from "../../constants/strings";

import { Mode } from "../../constants/enums";
import { Constants } from "../../constants/constants";

import "flatpickr/dist/flatpickr.css";

interface Props {
    value?: any;
    mode?: number;
    label?: string,
    isFullRow?: boolean;
    required?: boolean,
    disabled?: boolean,
    dateFormat?: string;
    placeholder?: string,
    errorMessage?: string,
    variant?: "standard" | "outlined";
    onChangeValue: (value: any) => void;
    options?: Options;
}

const DateTimePicker = ({
    mode,
    label,
    variant,
    options,
    required,
    disabled,
    isFullRow,
    dateFormat,
    placeholder,
    errorMessage,
    onChangeValue,
    ...rest
}: Props): JSX.Element => {
    const languageLocal = Strings.getLanguage();

    if (mode === Mode.View) {
        return (
            <TitleValue
                title={label}
                isFullRow={isFullRow}
                value={Helpers.formatDate(rest.value, "DD/MM/YYYY: hh:mm")}
            />
        );
    }

    return (
        <Flatpickr
            {...rest}
            onChange={(e: any) => onChangeValue(e[0])}
            options={{
                time_24hr: true,
                allowInput: true,
                enableTime: true,
                dateFormat: "d/m/Y H:i",
                "locale": (languageLocal === Constants.DefaultLanguage) ? Vietnamese : undefined,
                ...options
            }}
            render={({ defaultValue }: any, ref: any) => (
                <FormField
                    // {...rest.input}
                    fullWidth
                    label={label}
                    inputRef={ref}
                    required={required}
                    disabled={disabled}
                    placeholder={placeholder}
                    errorMessage={errorMessage}
                    defaultValue={defaultValue}
                    variant={variant || "standard"}
                    InputLabelProps={{ shrink: true }}
                />
            )}
        />
    );
}

DateTimePicker.defaultProps = {
    placeholder: "DD/MM/YYYY hh:mm"
};

export default memo(DateTimePicker);